import { PaginatedParams, PaginatedResultV2 } from "services/@types";
import apiInputService from "services/apiInputService";
import { WorkerData } from "./types";
import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";

const fetchGetWorkers = async (
  params: PaginatedParams
): Promise<PaginatedResultV2<WorkerData>> => {
  const workers = await apiInputService.get(`/Worker/paginated`, {
    params: { ...params },
  });
  const { data } = workers;

  return data._metadata as PaginatedResultV2<WorkerData>;
};

export const useGetWorkers = (
  params?: PaginatedParams,
  options?: {
    staleTime: number;
    onSuccess: (data: PaginatedResultV2<WorkerData>) => void;
  }
) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["worker-paginated", subscription?.subscriptionId, params],
    () => fetchGetWorkers(params),
    {
      ...options,
      enabled: !!subscription?.subscriptionId,
      keepPreviousData: true,
    }
  );
};
